import { useState, useEffect, useCallback } from 'react'
import { supabase } from '../lib/supabase'
import { useAuth } from './useAuth'

/**
 * Loads all position_projects for the current user and provides lookup helpers.
 * Returns maps for trade_id → project_id and symbol → project_id.
 */
export function usePositionProjectLookup() {
  const { user } = useAuth()
  const [projectsByTradeId, setProjectsByTradeId] = useState({})
  const [projectsBySymbol, setProjectsBySymbol] = useState({})
  const [loaded, setLoaded] = useState(false)

  const reload = useCallback(async () => {
    if (!user) return
    const { data } = await supabase
      .from('position_projects')
      .select('id, trade_id, symbol, stage')
      .eq('user_id', user.id)
      .eq('is_draft', false)

    const byTradeId = {}
    const bySymbol = {}
    for (const p of data || []) {
      if (p.trade_id) byTradeId[p.trade_id] = p.id
      // For symbol lookup, prefer active projects
      if (!bySymbol[p.symbol] || p.stage === 'active') {
        bySymbol[p.symbol] = p.id
      }
    }
    setProjectsByTradeId(byTradeId)
    setProjectsBySymbol(bySymbol)
    setLoaded(true)
  }, [user])

  useEffect(() => { reload() }, [reload])

  return { projectsByTradeId, projectsBySymbol, loaded, reload }
}
